import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PublicLicenseSearchService = /** @class */ (function () {
    function PublicLicenseSearchService(http) {
        this.http = http;
        this.licenseSearchUrl = 'licenses/';
    }
    PublicLicenseSearchService.prototype.performSearch = function (searchParams) {
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.get(this.licenseSearchUrl, { params: searchParams, headers: headers });
    };
    PublicLicenseSearchService.ngInjectableDef = i0.defineInjectable({ factory: function PublicLicenseSearchService_Factory() { return new PublicLicenseSearchService(i0.inject(i1.HttpClient)); }, token: PublicLicenseSearchService, providedIn: "root" });
    return PublicLicenseSearchService;
}());
export { PublicLicenseSearchService };
